module.exports = __webpack_public_path__ + "img/jordan.34d7eca8.svg";